import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import Tooltip from '../../../../Components/Popup/Tooltip';

interface Props {
	trigger: React.ReactNode;
}

const ElectronicSignatureUnavailableTooltip: React.FC<Props> = ({
	trigger,
}) => {
	return (
		<Tooltip trigger={trigger}>
			<div>
				<Text tx='component.signButton.certificatesSetupHint' inline />{' '}
				<img
					src='/dist/icons/gear-solid-white.svg'
					height='18px'
					alt='settings icon'
				/>
				{''} - <Text tx='component.certificates.myCertificates' inline />
			</div>
		</Tooltip>
	);
};

export default ElectronicSignatureUnavailableTooltip;
